//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  name: 'MdmProgressCircle',
  props: {
    progress: {
      type: Number,
      default: 0
    },
    color: {
      type: String,
      default: ''
    },
    size: {
      type: Number,
      default: 20
    }
  }
};